import { Link } from 'react-router-dom';
import { UserCircleIcon, CheckBadgeIcon, GiftIcon, HeartIcon, CreditCardIcon, VideoCameraIcon } from '@heroicons/react/24/solid';

// Reusable component for each step in the process
const StepCard = ({ icon, stepNumber, title, children }) => (
    <div className="flex">
        <div className="flex-shrink-0 mr-6">
            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-orange-500 text-white shadow-lg">
                {icon}
            </div>
        </div>
        <div>
            <h3 className="text-lg font-semibold text-gray-500 dark:text-gray-400">Step {stepNumber}</h3>
            <h4 className="mt-1 text-2xl font-bold text-gray-900 dark:text-white">{title}</h4>
            <p className="mt-2 text-gray-600 dark:text-gray-300 leading-relaxed">
                {children}
            </p>
        </div>
    </div>
);


export default function HowItWorksPage() {
    return (
        <div className="bg-gray-50 dark:bg-gray-900">
            <header className="bg-white dark:bg-gray-800 py-16 text-center border-b dark:border-gray-700">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 dark:text-white">How It Works</h1>
                    <p className="mt-4 text-xl text-gray-500 dark:text-gray-400 max-w-3xl mx-auto">
                        A transparent and direct path from generosity to independence.
                    </p>
                </div>
            </header>
            
            <main className="container mx-auto px-4 py-20">
                <div className="max-w-4xl mx-auto space-y-20">
                    
                    {/* --- RECIPIENT FLOW --- */}
                    <section>
                        <h2 className="text-3xl font-bold text-center mb-12 text-orange-500">For Recipients</h2>
                        <div className="space-y-12">
                            <StepCard icon={<UserCircleIcon className="w-8 h-8"/>} stepNumber="1" title="Register & Complete Your Profile">
                                Begin by creating an account and selecting the "Start a Campaign" role. You'll be guided to our secure onboarding page to provide personal details, a brief bio, and upload verification documents like a profile photo and a valid ID. This is a one-time process to ensure all recipients on our platform are verified.
                            </StepCard>
                            <StepCard icon={<GiftIcon className="w-8 h-8"/>} stepNumber="2" title="Select a Product & Submit Your Request">
                                Once your profile is complete, you can browse our catalog of approved assistive technology Product (warehoused by accesstech innovation owners of Givetech) Choose the one item you need and write a compelling reason explaining how it will impact your daily life. This "reason" is what donors will see.
                            </StepCard>
                             <StepCard icon={<CheckBadgeIcon className="w-8 h-8"/>} stepNumber="3" title="Admin Review & Approval">
                                Our dedicated admin team will review your request. They may edit your "reason" for clarity before approving it. Once approved, your campaign goes live on our website for donors to see. You can check the status of your request at any time in your dashboard.
                            </StepCard>
                             <StepCard icon={<VideoCameraIcon className="w-8 h-8"/>} stepNumber="4" title="Receive Your Gift & Say Thanks">
                                When a generous donor funds your item, we'll notify you! You must then come to our collection center in Lagos with your original ID to pick up your new device. After you've received your gift, our team will help you record a short "Thank You" video, which becomes a success story to inspire other donors.
                            </StepCard>
                        </div>
                    </section>
                    
                    <div className="border-t border-gray-300 dark:border-gray-700 my-16"></div>

                    {/* --- DONOR FLOW --- */}
                    <section>
                        <h2 className="text-3xl font-bold text-center mb-12 text-orange-500">For Donors</h2>
                         <div className="space-y-12">
                            <StepCard icon={<HeartIcon className="w-8 h-8"/>} stepNumber="1" title="Discover & Select a Campaign">
                                Browse our public campaigns page to see all the approved requests from our verified recipients. Read their stories, see the specific technology they need, and choose a campaign that resonates with you.
                            </StepCard>
                             <StepCard icon={<CreditCardIcon className="w-8 h-8"/>} stepNumber="2" title="Make a Secure Donation">
                                Once you've chosen a campaign, add it to your gift bag and proceed to our secure checkout powered by Paystack. You can donate as a registered user to track your giving history or as a guest. Your contribution directly funds the purchase of that specific item.
                            </StepCard>
                             <StepCard icon={<VideoCameraIcon className="w-8 h-8"/>} stepNumber="3" title="See Your Impact">
                                After Payment your recipient would be contacted to come collect the item at accesstechinnovation and research center, we'll upload their "Thank You" video. If you created an account, you can log in to your "My Gifts" page to see the video and the direct impact of your generosity.
                            </StepCard>
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
}